import { useQuery } from '@tanstack/react-query'
import { productTemplate } from '../../service/list'

function useGetProductTemplate() {
  return useQuery({
    queryKey: ['get-product-template'],
    queryFn: () => productTemplate(),
    staleTime: 6 * 1000,
  })
}

export default useGetProductTemplate
